import React from "react";
import "./Loading.css";

const Loading = () => {
  return <div class="lds-dual-ring"></div>;
};

export default Loading;
